module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "remittanceIntegration"
    }
  }, [_c('confirm-modal', {
    attrs: {
      "id": "confirmRemittanceRemoval"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.mensagem.confirmarExclusao'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoveRemittance",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmacaoModalCreateRemittance",
      "clickFunction": _vm.removeRemittance
    }
  })], 1)]), _c('remittance-integration-modal', {
    attrs: {
      "show": _vm.shown.detail,
      "remittance": _vm.remittance,
      "showRemovalButton": _vm.canRemoveRemittance
    },
    on: {
      "close-modal": _vm.closeDetailModal
    }
  }), _c('remittance-integration-creation-modal', {
    attrs: {
      "show": _vm.shown.new,
      "remittance-types": _vm.cleanRemittanceTypes
    },
    on: {
      "close-modal": _vm.closeNewRemittanceModal
    }
  }), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t("remessaIntegracao.titulos.titulo"),
      "subTitle": _vm.$t("remessaIntegracao.titulos.subtitulo")
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "id": "btnNovaRemessa",
      "label": _vm.$t("remessaIntegracao.labels.novoArquivo"),
      "clickFunction": _vm.loadNewRemittanceModal
    },
    slot: "new-button"
  })], 1), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t("remessaIntegracao.titulos.filtro")
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "exportFileFlag": _vm.isExportFile,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    on: {
      "update-flagExportingFile": function($event) {
        _vm.isExportFile = !_vm.isExportFile
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 365,
      "disableDateRange": _vm.disableDateRange
    },
    model: {
      value: (_vm.filters.period),
      callback: function($$v) {
        _vm.$set(_vm.filters, "period", $$v)
      },
      expression: "filters.period"
    }
  })], 1), _c('div', {
    staticClass: "row"
  }), _c('div', {
    staticClass: "row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.labels.consultaPor'))
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has("remessaRadioButton")),
      expression: "errors.has(\"remessaRadioButton\")"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("validacao.campoObrigatorio"))
    }
  }), _c('div', {
    staticClass: "radio radio-success no-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.origin),
      expression: "filters.origin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ("required"),
      expression: "\"required\""
    }],
    staticClass: "input",
    attrs: {
      "id": "dataGeracaoRadio-RemessaIntegracao",
      "type": "radio",
      "name": "remessaRadioButton",
      "value": "G",
      "checked": "checked",
      "disabled": _vm.disableDateRange
    },
    domProps: {
      "checked": _vm._q(_vm.filters.origin, "G")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.filters, "origin", "G")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "dataGeracaoRadio-RemessaIntegracao"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.dataGeracao"))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.origin),
      expression: "filters.origin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ("required"),
      expression: "\"required\""
    }],
    staticClass: "input",
    attrs: {
      "id": "periodoMovimentacaoRadio-RemessaIntegracao",
      "type": "radio",
      "name": "remessaRadioButton",
      "value": "M",
      "disabled": _vm.disableDateRange
    },
    domProps: {
      "checked": _vm._q(_vm.filters.origin, "M")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.filters, "origin", "M")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "periodoMovimentacaoRadio-RemessaIntegracao"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.periodoMovimentacao"))
    }
  })])])]), _c('div', {
    staticClass: "row row-filter-small"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "remittenceType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.tipoRemessa"))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "input",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('filters.type')
    },
    attrs: {
      "id": "remittenceType",
      "value": _vm.filters.type,
      "options": _vm.remittenceTypes,
      "label": "nome",
      "placeholder": _vm.$t("validacao.select.placeholder"),
      "data-vv-name": "filters.type",
      "name": "remittenceType",
      "disabled": _vm.filters.remittenceIds.length > 0
    },
    model: {
      value: (_vm.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "type", $$v)
      },
      expression: "filters.type"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("estabelecimentos.labels.nenhumResultado"))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule("filters.type", "required")),
      expression: "errors.firstByRule(\"filters.type\", \"required\")"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("validacao.campoObrigatorio"))
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.idsRemessa"))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.filters.remittenceIds,
      "read-only": false,
      "typeable": true,
      "type-only": true,
      "type-only-options": {
        isNumericOnly: true
      },
      "place-holders": {
        input: "remessaIntegracao.labels.digiteIdRemessa"
      },
      "disable-input": _vm.filters.sequenceNumber.length > 0
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.filters, "remittenceIds", $event)
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.numeroSequencia"))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.filters.sequenceNumber,
      "read-only": false,
      "typeable": true,
      "type-only": true,
      "type-only-options": {
        isNumericOnly: true
      },
      "place-holders": {
        input: "remessaIntegracao.labels.digiteNumeroSequencia"
      },
      "disable-input": _vm.filters.remittenceIds.length > 0
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.filters, "sequenceNumber", $event)
      }
    }
  })], 1)])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGrid),
      expression: "showGrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "RemessasIntegracao",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "remessaIntegracao",
      "cfgObj": _vm.treeGridCfg,
      "showExcluirRemessaButton": _vm.canRemoveRemittance
    },
    on: {
      "remittanceRemoval": _vm.remittanceRemoval
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-05d5d57d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d5d57d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/integration/remittanceIntegration/remittanceIntegration.pug
// module id = 1358
// module chunks = 0